import { Injectable } from '@angular/core';
import { datadogRum } from '@datadog/browser-rum';

@Injectable({
  providedIn: 'root',
})
export class DatadogService {
  logAction(actionName: string, attributes?: Record<string, any>) {
    datadogRum.addAction(actionName, attributes || {});
  }
}
